import React, { Component } from "react";
import ActionContainer from "../../../components/UIComponent/ActionTableComponent/actionContainer";
import ActionEditButton from "../../../components/UIComponent/ActionTableComponent/ActionEditButton";
import ActionDeleteButton from "../../../components/UIComponent/ActionTableComponent/ActionDeleteButton";
import { Navigate } from "react-router-dom";
import SwalServices from '../../../services/swalServices/SwalServices';
import { CommonSuccessMessages } from "../../../utils/Messages";
import { encryptAES } from "../../../utils/Encryption";
import CreateButton from '../../../components/UIComponent/Buttons/CreateButton';
import Table from "../../../components/table/Table";
import ActionToggleButton from "../../../components/UIComponent/ActionTableComponent/ActionToggleButton";
import AnnouncementServices from "../../../services/axiosServices/apiServices/AnnouncementServices";



export default class ManageAnnouncements extends Component {
    constructor(props) {
        super(props);
       
        this.swalServices = new SwalServices();
        this.AnnouncementServices = new AnnouncementServices();
        this.state = {
            route: "",
            isLoading: false,
            isUpdateLoading: false,
            pagination: {
                pageNo: 1,
                pageSize: 10,
                orderByColumn: "",
                orderFlag: 0,
                // searchText: "",
            },
            totalResultes: 0,
            publishedAnnouncementList: [],
            deletedBy: 1,
            deletedAppId: 1,
            featuredWelcomeTitle: '',
        };
    }

    componentDidMount() {
        this.getPublishedAnnouncementList();
    }

    getPublishedAnnouncementList = (pagination = this.state.pagination) => {
        this.setState({ isLoading: true });
        this.AnnouncementServices.getAnnouncementList(pagination).then((response) => {
            if (response.statusCode === 200 && response.responseItem != null) {
                const updatedList = response.responseItem.responseContent.itemList.map((item) => ({
                    ...item,
                    // redirectionLink: item.redirectionLink && item.redirectionLink.trim() !== "" ? item.redirectionLink : "-",
                    IsActive: item.status === "Active", 
                }));
                this.setState({ publishedAnnouncementList: updatedList });

           
                this.setState({ totalResultes: response.responseItem.responseContent.totalCount });
            }
            else {
                this.swalServices.Error(response.message);
            }
            this.setState({ isLoading: false });
        })
    }

    onDelete = (announcementId) => {
        if (announcementId !== null) {
            this.swalServices.Confirm(CommonSuccessMessages.Confirm_Question.replace("{0}", "Announcement"), CommonSuccessMessages.Confirm_Delete.replace("{0}", "Announcement detail"),
                CommonSuccessMessages.Yes_Text, CommonSuccessMessages.No_Text).then((response) => {
                    if (response) {
                        let request = {};
                        request.id = announcementId;
                        request.deletedBy = this.state.deletedBy;
                        this.AnnouncementServices.deleteAnnouncementDetails(request).then((response) => {
                            if (response.statusCode === 200 && response.responseItem != null) {
                                this.swalServices.Success("Announcement Detail deleted successfully.");
                                this.getPublishedAnnouncementList();
                            }
                            else {
                                this.swalServices.Error(response.message);
                            }
                            this.setState({ isLoading: false });
                        })
                    }
                })
        }
        else {
            this.swalServices.Error("Sorry! You can't delete this Member.");
        }
    }

    handleChange(event) {
        const value = event.target.value;
        this.setState({ featuredWelcomeTitle: value });
    }

    searchByName = (value) => {
        let detail = this.state.pagination;
        detail.pageNo = 1;
        detail.pageSize = 10;
        detail.searchText = value;
        this.setState({ pagination: { ...detail } });
        this.getPublishedAnnouncementList();
    }

    actions = (element, index, value) => {
        return (element !== "announcementDetailsId") ? null
            :
            <td>
                <ActionContainer>
                    <ActionToggleButton
                        className="mr-2"
                        index={index}
                        data={this.state.publishedAnnouncementList}
                        onToggleChage={this.onToggleChange.bind(this)}
                    />

                    <ActionEditButton
                        value={value}
                        id={index}
                        index={index}
                        onActionClick={this.onEdit}
                        text="Edit"
                    />

                      <ActionDeleteButton
                      value={value}
                      id={index}
                      index={index}
                      onActionClick={this.onDelete}
                      text="Delete"
                     />
                        {/* <ActionDeleteButton
                        value={value}
                        id={index}
                        index={index}
                        onActionClick={this.onDelete}
                        text="Delete"
                    /> */}
                </ActionContainer>
            </td>
    }

    onEdit = (id) => {
        this.setState({ route: '/AddEditAnnouncements/announcementId?=' + encryptAES(id) });
    }

    setPagination = (newPagination) => {
        this.setState({ pagination: newPagination });
        this.getPublishedAnnouncementList();
    };

    onToggleChange = (index, event) => {
        let announcementDetailsId = this.state.publishedAnnouncementList[index].announcementDetailsId;
        let statusId = 0
        if (this.state.publishedAnnouncementList[index].status === "Inactive") {
            statusId = 1;
        }
        else if (this.state.publishedAnnouncementList[index].status === "Active") {
            statusId = 0;
        }
        this.activeInActiveAnnouncement(announcementDetailsId, statusId);
    }

    activeInActiveAnnouncement = (id, statusId) => {
        let request = {};
        request.id = id;
        request.statusId = statusId;

        if (request.id > 0 && request.statusId != null) {
            this.AnnouncementServices.activeInActiveAnnouncement(request).then((response) => {
                if (response.statusCode === 200 && response.responseItem != null) {
                    if (response.responseItem.responseContent.hasError === false) {
                        if (statusId === 1) {
                            this.swalServices.SuccessWithAction("Announcement Detail Status has been Changed Successfully!", "OK").then((res) => {
                                this.getPublishedAnnouncementList();
                            });
                        }
                        else {
                            this.swalServices.SuccessWithAction("Announcement Detail Status has been Changed Successfully!", "OK").then((res) => {
                                this.getPublishedAnnouncementList();
                            });
                        }
                    }
                    else {
                        this.swalServices.Error(response.responseItem.responseContent.errorMessage);
                    }
                }
                else {
                    this.swalServices.Error(response.message);
                }
            });
        }
    }

    render() {
        if (this.state.route !== "") {
            return <Navigate to={this.state.route} />;
        }
        return (
            <div className="main-body-section">
                <div className="flex">
                    <div className="relative flex flex-col flex-1">
                        <main className="pb-10">

                            {/* Table Section */}
                            <div className="w-full mx-auto">
                                <div className="sm:flex sm:justify-between sm:items-center mb-8">
                                    <div className="mb-4 sm:mb-0">
                                        <h1 className="table-title-txt theme-color font-bold">
                                           Total {this.state.totalResultes} 
                                        </h1>
                                    </div>
                                    <CreateButton
                                        redirect="/AddEditAnnouncements"
                                        text="Create New"
                                    />
                                </div>
                                <div className="relative" tyle={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch', width: '100%' }}>
                                    <Table columns={[{ name: 'announcementTitle', title: 'Announcement Title' }, 
                                    // { name: 'redirectionLink', title: 'Redirection Link' },
                                    { name: 'orderingPosition', title: 'Ordering Position' }, { name: 'status', title: 'Status' }, { name: 'announcementDetailsId', title: 'Action' }]}
                                        rows={this.state.publishedAnnouncementList}
                                        isLoading={this.state.isLoading}
                                        sortingColumns={""}
                                        pagination={this.state.pagination}
                                        totalResultes={this.state.totalResultes}
                                        totalCount={this.state.totalResultes}
                                        setPagination={this.setPagination.bind(this)}
                                        customScope={[

                                            {
                                                column: 'announcementDetailsId',
                                                renderTableData: this.actions.bind(this)
                                            },
                                        ]} 
                                        style={{ width: '100%', tableLayout: 'fixed' }}
                                        />
                                </div>
                            </div>
                        </main>
                    </div>
                </div>
            </div>
        );

    }
}
